//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "POURQUOI CRÉER VOTRE BLOG D'ENTREPRISE ? - NANCOMCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Et oui, le blog d’entreprise ou professionnel a toujours le vent en poupe en 2021 ! Bloguer reste un outil indispensable pour se faire connaître sur internet, communiquer avec ses prospects ou encore diffuser de l’information à destination de ses partenaires et collaborateurs. Le blog est donc un outil marketing largement utilisé par les entreprises, qui y trouvent de nombreux bénéfices. Cet article a pour objectif de vous donner les avantages pour lesquels vous devez sauter le pas !",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: require("~/assets/img/blog/thumbnail-header-23.jpeg"),
        },
      ],
    };
  },
};
